export default "__VITE_ASSET__B7uCzGGg__"